import { Link } from 'react-router-dom';
import { SITE, SOCIAL_LINKS } from '@utils/constants';
import logo from '../../../../public/logo.png';

const FOOTER_SECTIONS = [
    {
        title: 'Platform',
        links: [
            { label: 'Products', href: '/products' },
            { label: 'Services', href: '/services' },
            { label: 'User Guide', href: '/user-guide' },
            { label: 'Features', href: '/features' },
            
            // { label: 'Solutions', href: '/solutions' },
        ],
    },
    {
        title: 'Legal',
        links: [
            { label: 'Privacy Policy', href: '#' },
            { label: 'Terms of Service', href: '#' },
            { label: 'Cookie Policy', href: '#' },
            { label: 'Security', href: '#' },
        ],
    },
];

const ICON_MAP = {
    twitter: <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />,
    linkedin: <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />,
    github: <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />,
    youtube: <path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z" />,
};

function SocialIcon({ icon }) {
    return (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            {ICON_MAP[icon]}
        </svg>
    );
}

function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="bg-primary-950 text-neutral-400" role="contentinfo">
            <div className="container-site py-16 lg:py-20">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-4">
                    {/* Brand column */}
                    <div className="lg:col-span-2 flex flex-col gap-5">
                        <Link to="/" className="text-3xl font-bold bg-gradient-to-r from-cyan-300 via-blue-300 to-cyan-400 bg-clip-text text-transparent hover:opacity-90 transition-opacity">
                            <img src={logo} alt="Company Logo" className="h-10 w-auto" />
                        </Link>
                        <p className="text-sm leading-relaxed max-w-xs">
                            {SITE.description}
                        </p>
                        <p className="text-xs text-neutral-500 font-medium uppercase tracking-wider">
                            Powered by EdgeMind · Presented by Elliance
                        </p>
                        {/* Social links */}
                        <div className="flex items-center gap-3">
                            {SOCIAL_LINKS.map(({ platform, href, icon }) => (
                                <a
                                    key={platform}
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={platform}
                                    className="w-9 h-9 rounded-lg bg-primary-900 flex items-center justify-center text-neutral-400 hover:bg-accent-500 hover:text-white transition-all duration-200"
                                >
                                    <SocialIcon icon={icon} />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Nav columns */}
                    {FOOTER_SECTIONS.map(({ title, links }) => (
                        <div key={title} className="flex flex-col gap-4">
                            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">{title}</h3>
                            <ul className="flex flex-col gap-3" role="list">
                                {links.map(({ label, href }) => (
                                    <li key={label}>
                                        <Link
                                            to={href}
                                            className="text-sm hover:text-accent-400 transition-colors duration-200"
                                        >
                                            {label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Bottom bar */}
                <div className="mt-16 pt-8 border-t border-primary-900 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs">
                    <p>© {year} {SITE.name} by Elliance. All rights reserved.</p>
                    <p className="flex items-center gap-1">
                        Building Sovereign Edge AI —
                        <span className="text-accent-400 font-semibold ml-1">EdgeMind Platform</span>
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
